import React from 'react';
import loadable from '@loadable/component';

const NpsSurveyContainer = loadable(() => import('features/Settings/Membership/NpsSurvey/NpsSurveyContainer'));

export const NpsSurveyRoute = () => ({
  path: 'settings/nps-survey',
  indexRoute: {
    component: props => <NpsSurveyContainer {...props} />,
  },
});
